import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const AITPRJ05 = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO SECTION */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage: "url('/Images/tour/6dd6f408-13d_big.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Rajasthan Desert Tour (AITP / RJ-05)</h1>

            <p className="hero-subtitle">
              5 Nights / 6 Days • Jaipur – Bikaner – Jaisalmer – Jodhpur
            </p>

            <div className="hero-price">
              Starting From <span>₹21,500*</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + ENQUIRY */}
        <Row className="mb-4">

          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/87433e47-b4c_big.jpg" alt="" />
                <img src="/Images/tour/aa191865-c88_big.jpg" alt="" />
                <img src="/Images/tour/25bff7bb-1c7_big.jpg" alt="" />
              </Slider>
            </div>
          </Col>

          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹21,500*</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Rajasthan Cultural & Desert Circuit</h1>
              <p>Jaipur • Bikaner • Jaisalmer • Jodhpur | 5 Nights / 6 Days</p>
            </div>

            {/* HIGHLIGHTS */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Junagarh Fort Bikaner</Col>
                <Col md={6}>✔ Karni Mata Temple</Col>
                <Col md={6}>✔ Camel Safari Sam Sand Dunes</Col>
                <Col md={6}>✔ Jaisalmer Golden Fort</Col>
                <Col md={6}>✔ Patwon Ki Haveli</Col>
                <Col md={6}>✔ Mehrangarh Fort Jodhpur</Col>
                <Col md={6}>✔ Jaswant Thada</Col>
                <Col md={6}>✔ Jaipur City Palace & Hawa Mahal</Col>
              </Row>
            </div>

            {/* OVERVIEW */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Experience the royal heritage and desert beauty of Rajasthan.
                Explore historic forts, golden sand dunes, vibrant markets,
                camel safaris and magnificent palaces across Bikaner,
                Jaisalmer, Jodhpur and Jaipur.
              </p>
            </div>

            {/* ITINERARY */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Jaipur to Bikaner
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Bikaner. Visit Junagarh Fort, Camel Breeding Farm
                    and Karni Mata Temple. Overnight stay in Bikaner.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Bikaner to Jaisalmer
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Jaisalmer – the Golden City. Evening visit Sam
                    Sand Dunes for camel ride experience. Overnight stay.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Jaisalmer Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Jaisalmer Fort, Patwon Ki Haveli, Salim Singh Ki
                    Haveli, Gandhi Sagar Tank and Barabagh Hill.
                    Overnight stay in Jaisalmer.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Day 4 – Jaisalmer to Jodhpur
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Jodhpur. Visit Mehrangarh Fort,
                    Moti Mahal, Phool Mahal, Jaswant Thada
                    and Umaid Public Gardens.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Day 5 – Jodhpur to Jaipur
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Jaipur. Visit City Palace,
                    Observatory (Jantar Mantar), Ram Niwas
                    Garden and drive past Hawa Mahal.
                    Overnight stay in Jaipur.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    Day 6 – Jaipur Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    After breakfast check out from hotel
                    and drop at Jaipur Airport/Railway Station.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* INCLUSION / EXCLUSION */}
            <div className="content-box">
              <Row>
                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul>
                    <li>Hotel Accommodation</li>
                    <li>Daily Breakfast</li>
                    <li>Private Vehicle</li>
                    <li>All Sightseeing Tours</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul>
                    <li>Monument Entry Fees</li>
                    <li>Camel Safari Charges</li>
                    <li>Personal Expenses</li>
                    <li>Travel Insurance</li>
                  </ul>
                </Col>
              </Row>
            </div>

            {/* HOTEL */}
            <div className="content-box">
              <h3>Hotel Details</h3>
              <p>
                Deluxe category hotels in Bikaner, Jaisalmer, Jodhpur
                and Jaipur ensuring comfortable and relaxing stays.
              </p>
            </div>

            {/* RATE */}
            <div className="content-box">
              <h3>Rate & Summary</h3>
              <p>
                Starting price ₹21,500 per person on twin sharing basis.
                Rates may vary according to travel season.
              </p>
            </div>

            {/* TERMS */}
            <div className="content-box">
              <h3>Terms & Conditions</h3>
              <ul>
                <li>Booking subject to availability.</li>
                <li>Advance payment required.</li>
                <li>Cancellation policy applicable.</li>
              </ul>
            </div>

            {/* TRAVEL TIPS */}
            <div className="content-box">
              <h3>Travel Tips</h3>
              <ul>
                <li>Carry light cotton clothes for daytime.</li>
                <li>Winter nights can be cold in desert regions.</li>
                <li>Wear comfortable walking shoes.</li>
                <li>Carry sunscreen & sunglasses.</li>
              </ul>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default AITPRJ05;